import Http from "@/commons/Http";

const path = 'api/public/client';

export default {

    async getAll(protocolId, accessCode){
        return Http.get(`${path}/${protocolId}/${accessCode}`);
    },

    async getProtocolTypeServicesWithUnderAge(protocolId, accessCode){
        return Http.get(`${path}/${protocolId}/${accessCode}/with-underage`);
    },

    async save(dto, protocolId, accessCode){
        return Http.post(`${path}/${protocolId}/${accessCode}`, dto);
    },

    async edit(dto, clientId = '', protocolId, accessCode){
        return Http.post(`${path}/${protocolId}/${accessCode}/${clientId}`, dto);
    },

    async delete(protocolClientId = '', protocolId, accessCode){
        return Http.delete(`${path}/${protocolId}/${accessCode}/${protocolClientId}`);
    },

    async deleteProtocolTypeService(protocolTypeService = '', protocolId, accessCode){
        return Http.delete(`${path}/${protocolId}/${accessCode}/protocol-type-service/${protocolTypeService}`);
    },

    async sendNotification(message, protocolId, accessCode){
        return Http.post(`${path}/${protocolId}/${accessCode}/send-notification`, {message});
    },

}
